import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const MediumSend = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.72902 0.299988C1.40025 0.299988 0.333059 1.35733 0.333059 2.64313C0.333059 3.00802 0.429018 3.34307 0.576147 3.64214C0.583055 3.66402 0.591048 3.68559 0.600109 3.70677C0.622137 3.75825 0.644051 3.80152 0.663141 3.83657C0.679036 3.88838 0.700962 3.93838 0.728629 3.98553L2.67374 7.29999L8.9998 7.29999C9.3864 7.29999 9.6998 7.61339 9.6998 7.99999C9.6998 8.38659 9.3864 8.69999 8.9998 8.69999L2.67568 8.69999L0.752171 11.9776C0.693648 12.0418 0.65482 12.1083 0.62915 12.1654C0.601745 12.2085 0.564179 12.277 0.538694 12.3664C0.393941 12.6633 0.299805 12.9954 0.299805 13.3568C0.299805 14.6426 1.36699 15.7 2.69577 15.7C3.2021 15.7 3.65292 15.5405 4.02688 15.3007L4.06851 15.2729L14.2059 10.1741C14.2159 10.1691 14.2257 10.1638 14.2354 10.1584C15.1008 9.80821 15.6998 8.9748 15.6998 8.00554C15.6998 7.07452 15.1472 6.26885 14.3366 5.89641C14.2667 5.84554 14.1882 5.80816 14.1051 5.78598L4.10241 0.727453L4.07109 0.706394L4.06007 0.699329C3.68611 0.459616 3.23536 0.299988 2.72902 0.299988Z",
            fill: "currentColor"
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M3.89311 7.99445L1.33254 3.63124V3.59794C1.31037 3.55353 1.27712 3.50912 1.24386 3.4314V3.4092C1.11085 3.16495 1.03325 2.9096 1.03325 2.64314C1.03325 1.75496 1.77593 1 2.72922 1C3.08393 1 3.40538 1.11102 3.6825 1.28866L3.71576 1.31086L3.74901 1.33307L13.8915 6.46233H13.9248L13.958 6.49564C14.5788 6.73989 15 7.32831 15 8.00555C15 8.68279 14.5788 9.27121 13.958 9.51546H13.9248L13.8915 9.54877L3.71576 14.6669L3.6825 14.6891L3.64925 14.7113C3.37213 14.889 3.05067 15 2.69596 15C1.74268 15 1 14.245 1 13.3569C1 13.0904 1.07759 12.8351 1.21061 12.5908V12.5686C1.21061 12.5464 1.23278 12.5242 1.24386 12.5131C1.24386 12.4909 1.26603 12.4798 1.26603 12.4687C1.26603 12.4576 1.26603 12.4465 1.27712 12.4465L1.29929 12.4243L1.32146 12.391L3.88203 8.02776L3.89311 7.99445Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M3.89331 7.99445H8.89252",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};

export { MediumSend as default };
